define('modules/editor/models/property_groups/custom_amp_script',['require','exports','module','./base'],function(require, exports, module) {
  "use strict";

  var BasePropertyGroup = require('./base');

  module.exports = BasePropertyGroup.extend({
    name: 'form:customAMPScript',
    properties: [
        'customScriptContent',
        'customScriptURL'
    ]
  });
});

